import React, { useState } from 'react';
import './Contact.css';
import { FaEnvelope, FaUser, FaPaperPlane, FaFacebook, FaInstagram, FaFacebookF } from 'react-icons/fa';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [status, setStatus] = useState({
    submitted: false,
    submitting: false,
    error: null
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ submitting: true, submitted: false, error: null });

    // Simulate a short delay
    await new Promise(resolve => setTimeout(resolve, 1000));

    setStatus({
      submitted: true,
      submitting: false,
      error: null
    });
    
    // Reset form
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: ''
    });
  };

  return (
    <div className="contact-page">
      <div className="contact-hero">
        <h1>Contact Us</h1>
        <p>We'd love to hear from you! Send us a message and we'll respond as soon as possible.</p>
      </div>

      <div className="contact-container">
        <div className="contact-info">
          <div className="info-card">
            <FaEnvelope className="info-icon" />
            <h3>Email Us</h3>
            <p>info@learnpulaar.com</p>
          </div>
          <div className="info-card">
            <FaUser className="info-icon" />
            <h3>Follow Us</h3>
            <p>Join our community on social media</p>
          </div>
        </div>

        <div className="contact-form-container">
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Your name"
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="Your email address"
              />
            </div>

            <div className="form-group">
              <label htmlFor="subject">Subject</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
                placeholder="What is this regarding?"
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                placeholder="Your message"
                rows="6"
              />
            </div>

            <button 
              type="submit" 
              className="submit-button"
              disabled={status.submitting}
            >
              {status.submitting ? (
                'Sending...'
              ) : (
                <>
                  <FaPaperPlane className="submit-icon" />
                  Send Message
                </>
              )}
            </button>

            {status.submitted && (
              <div className="success-message">
                Thank you for your message! We'll get back to you soon. If you don't hear from us, please email us at info@learnpulaar.com
              </div>
            )}

            {status.error && (
              <div className="error-message">
                {status.error}
              </div>
            )}
          </form>
        </div>

        <div className="social-section">
          <h2>Join Our Community</h2>
          <p>Connect with us on social media to stay updated with the latest learning resources, cultural events, and community activities.</p>
          <div className="social-buttons">
            <a href="https://www.facebook.com/learnpulaar" target="_blank" rel="noopener noreferrer" className="social-button facebook">
              <FaFacebookF className="social-icon" />
              Follow Us on Facebook
            </a>
            <a href="https://www.instagram.com/learnpulaar" target="_blank" rel="noopener noreferrer" className="social-button instagram">
              <FaInstagram className="social-icon" />
              Follow Us on Instagram
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact; 